export var getClassDuration = function (seconds, intl) {
    var hours = Math.floor(seconds / 3600);
    var secondsMutated = seconds % 3600;
    var minutes = Math.floor(secondsMutated / 60);
    var hoursPart = '';
    if (hours > 0) {
        hoursPart = intl.formatNumber(hours, {
            style: 'unit',
            unit: 'hour',
            unitDisplay: 'narrow',
        });
    }
    var minutesPart = intl.formatNumber(minutes, {
        style: 'unit',
        unit: 'minute',
        unitDisplay: 'narrow',
    });
    return intl.formatList([hoursPart, minutesPart].filter(function (n) { return n; }), {
        type: 'unit',
        style: 'narrow',
    });
};
//# sourceMappingURL=class-duration-formatter.js.map